<template>
        <selectize class="form-control"
                   v-model="selection"
                   :options="carehomes"
                   labelField="name"
                   valueField="name"
                   searchField="name">
        </selectize>
</template>
<script>
    //import forminput from "./../../corecontrols/forminput/forminput.scp.html"
    //import { FormElementController , FormElementValidator } from './../../../scripts/formcontrols'
    import { CarehomeDto } from './../../../dto/carehomedto'
    import Dal from './../../../scripts/dataaccess'
    import selectize from './../../corecontrols/selectize/selectize.scp.html'

    export default {
        props: ['value', 'initialid'],
        data: function () {
            return {
                selection: {},
                carehomes : []
            };
        },
        watch: {
            selection: function () {
                this.$emit('input', this.selection);
            }
        },
        mounted: function () {
            var dal = new Dal();
            var that = this;
            dal.GetCarehomes().then(records => {

                var data = [];
                for (var carehome of records) {
                    if (this.$root.Carehomes.some(c => c.id === carehome.id)) {
                        data.push(carehome);
                    }
                }
                console.log("Filtered carehome data", data);
                that.carehomes = data;
                that.selection = that.carehomes[0]
                console.log("Initial Id", that.initialid)
                if (that.initialid) {
                    if (that.carehomes.filter(c => c.id == that.initialid).length > 0) {
                        var selected = that.carehomes.find(c => c.id == that.initialid)
                        that.selection = selected;
                        console.log("selection",that.selection)
                    }
                }
            });
        },
        components: {
            selectize
        }
    }
</script>


// WEBPACK FOOTER //
// carehomeselector.scp.html?7bd13173